import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AppNotification } from '@app/helpers';
import { AuthService, LocalStorageService } from '@app/services';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  resetPasswordForm: FormGroup = new FormGroup({});
  emailSent: boolean = false;
  token: string | null;
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if(this.token == null) {
      AppNotification.error('Token not found!')
      this.router.navigate([APP_ROUTES.LOGIN])
    }

    this.resetPasswordForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
  }

  submitResetPassword() {
    if(!this.resetPasswordForm?.value.password) {
      AppNotification.error("password cannot be empty!")
      return
    }
    if(!this.resetPasswordForm?.value.confirmPassword) {
      AppNotification.error("password cannot be empty!")
      return
    }
    if(this.resetPasswordForm?.value.password != this.resetPasswordForm?.value.confirmPassword) {
      AppNotification.error("password and confirm password mus be same!")
      return
    }

    this.authService.resetPassword(this.token!, this.resetPasswordForm?.value.password).subscribe({
      next: (res: any) => {
        this.emailSent = true;
        AppNotification.success("Password reset successfull!");
        this.router.navigate([APP_ROUTES.LOGIN]);
      },
      error: (error) => {
        AppNotification.error(error.error.data)
      }
    })

  }

  ngOnDestroy(): void {

  }

}
